export default function copy(): string {
    return `
----------------------------------------------------------------------
███████╗███████╗██████╗  ██████╗ ███╗   ██╗███████╗
╚══███╔╝██╔════╝██╔══██╗██╔═══██╗████╗  ██║██╔════╝
  ███╔╝ █████╗  ██████╔╝██║   ██║██╔██╗ ██║█████╗  
 ███╔╝  ██╔══╝  ██╔══██╗██║   ██║██║╚██╗██║██╔══╝  
███████╗███████╗██║  ██║╚██████╔╝██║ ╚████║███████╗
╚══════╝╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
 @version 1.0.0
 @time 2022年1月12日
 @copy 长沙零动科技
----------------------------------------------------------------------`
}
